import { io } from 'socket.io-client';

let socket = null;

export function connectSocket() {
  const token = localStorage.getItem('token');
  if (!token) return null;

  if (socket?.connected) return socket;

  const url = process.env.REACT_APP_WS_URL || window.location.origin;
  socket = io(url, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
  });

  socket.on('connect', () => console.log('Socket connected'));
  socket.on('disconnect', (reason) => console.log('Socket disconnected:', reason));
  socket.on('connect_error', (err) => console.error('Socket error:', err.message));

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getSocket() {
  return socket;
}

export function useSocket(events, deps = []) {
  // Used as a hook helper: call in component with { 'event:name': handler }
  return { socket, on: (event, fn) => socket?.on(event, fn), off: (event, fn) => socket?.off(event, fn) };
}
